export const NO05_STATS_REQUEST = 'NO05_STATS_REQUEST';
export const NO05_STATS_SUCCESS = 'NO05_STATS_SUCCESS';
export const NO05_STATS_FAILURE = 'NO05_STATS_FAILURE';

export const NO05_SEARCH_REQUEST = 'NO05_SEARCH_REQUEST';
export const NO05_SEARCH_SUCCESS = 'NO05_SEARCH_SUCCESS';
export const NO05_SEARCH_FAILURE = 'NO05_SEARCH_FAILURE';

export const NO05_LOAD_MORE_REQUEST = 'NO05_LOAD_MORE_REQUEST';
export const NO05_LOAD_MORE_SUCCESS = 'NO05_LOAD_MORE_SUCCESS';
export const NO05_LOAD_MORE_FAILURE = 'NO05_LOAD_MORE_FAILURE';

export const NO05_SET_STATUS = 'NO05_SET_STATUS';
export const NO05_SET_DATE = 'NO05_SET_DATE';
export const NO05_SET_DELIVERY_FILTER = 'NO05_SET_DELIVERY_FILTER';
export const NO05_CLEAR_RESULTS = 'NO05_CLEAR_RESULTS';
export const NO05_RESET_FORM = 'NO05_RESET_FORM';
export const NO05_CLEAR_COMPONENT_STORE = 'NO05_CLEAR_COMPONENT_STORE';

export const NO05_SELECT_ALL = 'NO05_SELECT_ALL';
export const NO05_SET_SELECTED = 'NO05_SET_SELECTED';

export const NO05_ORDER_DETAIL_REQUEST = 'NO05_ORDER_DETAIL_REQUEST';
export const NO05_ORDER_DETAIL_SUCCESS = 'NO05_ORDER_DETAIL_SUCCESS';
export const NO05_ORDER_DETAIL_FAILURE = 'NO05_ORDER_DETAIL_FAILURE';
export const NO05_ORDER_DETAIL_CLEAR = 'NO05_ORDER_DETAIL_CLEAR';
